import API from '@/services/api';
import router from '@/router';

export default {
  fetchAttendanceByStudent() {
    return API().get(`students/${router.currentRoute.params.id}/attendance`);
  },
  addAttendanceRecord(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/attendance`,
      params
    );
  },
  updateAttendanceRecord(params) {
    return API().put(
      `students/${params.student_id}/attendance/${params.id}`,
      params
    );
  },
  deleteAttendanceRecord(id) {
    return API().delete(
      `students/${router.currentRoute.params.id}/attendance/${id}`
    );
  },
  fetchAttendanceByTeacher() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-attendance`
    );
  },
  fetchOneMonthAttendanceByTeacher(params) {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-attendance/${params.year}/${params.month}`
    );
  },
  addOneMonthAttendanceByTeacher(params) {
    return API().post(
      `teachers/${router.currentRoute.params.id}/student-attendance`,
      params
    );
  },
  bulkUpdateOneMonthAttendanceByTeacher(params) {
    params.map(item => {
      delete item.student_name;
      return item;
    });

    return API().put(
      `teachers/${router.currentRoute.params.id}/student-attendance`,
      params
    );
  },
  addBulkAttendanceRecords(params) {
    params.map(item => {
      delete item.student_name;
      delete item.id;
      return item;
    });
    return API().post(
      `teachers/${router.currentRoute.params.id}/student-attendance`,
      params
    );
  },
  fetchAttendanceSummaryTable() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/student-attendance-summary`
    );
  },
};
